var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HeaderPDF"},[_c('a',{attrs:{"href":_vm.caminhoPdf + _vm.linkPdf,"download":_vm.tituloPdf+'.pdf',"title":_vm.tituloPdf+'.pdf'}},[_c('span',[_vm._v("Baixar "+_vm._s(_vm.sectionName))]),_vm._v(" "),_c('i',{staticClass:"small material-icons"},[_vm._v("picture_as_pdf")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aebcd21e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/HeaderPDF.vue
// module id = null
// module chunks = 